module.exports = __webpack_public_path__ + "static/img/1_muke.9babe18d.png";